// src/pages/authors/UpdateAuthor.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
import { AuthorType } from "../../../types/Library";
import { updateAuthor } from "../../../services/library/author";
import { routes } from "../../../routes";
import { Button, Card, Flex, Spinner } from "@radix-ui/themes";
import TextFieldComponent from "../../../components/inputs/Textfield/TextfieldComponent";
import { AuthorFormValidation } from "./AuthorFormValidation";
import { RootState } from "../../../redux/store";
import { useAppDispatch } from "../../../hooks/hooks";
import { resetAuthorData } from "../../../redux/slices/library/author";
import toast from "react-hot-toast";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";

export const UpdateAuthor = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const mutation = useMutation({ mutationFn: updateAuthor, mutationKey: "updateAuthor" });
    const authorFormData = useSelector((state: RootState) => state.author);

    const { control, handleSubmit, formState: { errors } } = useForm<AuthorType>({
        resolver: yupResolver(AuthorFormValidation),
        defaultValues: authorFormData,
        mode: "onBlur",
    });

    const onSubmit = handleSubmit(async (data) => {
        try {
            await mutation.mutateAsync(data);
            toast.success("Autor atualizado com sucesso!");
            handleBack();
        } catch (error: any) {
            toast.error(`Erro: ${error.message}`);
        }
    });

    const handleBack = () => {
        navigate(routes.authors);
        dispatch(resetAuthorData());
    };

    return (
        <form onSubmit={onSubmit} noValidate>
            <Card size="1">
                <Flex direction="column" gap="4">
                    <TextFieldComponent
                        name="fullname"
                        label="Nome Completo"
                        control={control}
                        errors={errors}
                        fieldProps={{ placeholder: "Nome Completo" }}
                        required={true}
                    />
                    <Flex direction="row" gap="4" style={{ alignSelf: "end" }}>
                        <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutation.isLoading}>
                            <ChevronLeftIcon /> Voltar
                        </Button>
                        <Button type="submit" disabled={mutation.isLoading}>
                            {mutation.isLoading ? <Spinner loading /> : <EnterIcon />}
                            Guardar
                        </Button>
                    </Flex>
                </Flex>
            </Card>
        </form>
    );
};
